export { default as useCacheLifestyles } from './useCacheLifestyles';
